export default __webpack_public_path__ + "static/media/school_free_post_donation.7701fd39.svg";